


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTBLOGSECTION
// REJECTBLOGSECTION


const REJECTBLOGSECTION= createAsyncThunk(
  "rejectBlogSection/rejectBlogSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectBlogSectionSlice = createSlice({
  name: "rejectBlogSectionSlice",
  initialState: {
    rejectBlogSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectBlogSection: (state) => {
        state.rejectBlogSection.loading = false
        state.rejectBlogSection.error = false
        state.rejectBlogSection.data = []
        state.rejectBlogSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTBLOGSECTION.fulfilled, (state, action) => {
      state.rejectBlogSection = {
        ...state.rejectBlogSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTBLOGSECTION.pending, (state, action) => {
      state.rejectBlogSection = {
        ...state.rejectBlogSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTBLOGSECTION.rejected, (state, action) => {
      state.rejectBlogSection = {
        ...state.rejectBlogSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectBlogSectionAction = {
    REJECTBLOGSECTION,
};

export { rejectBlogSectionAction };
export default rejectBlogSectionSlice.reducer;
export const {setInitialStateOfrejectBlogSection} = rejectBlogSectionSlice.actions
